import { useState } from 'react';
import { Link } from 'react-scroll';

interface NavItem {
  id: string;
  label: string;
}

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const navItems: NavItem[] = [
    { id: 'summary', label: 'Summary' },
    { id: 'experience', label: 'Experience' },
    { id: 'skills', label: 'Skills' },
    { id: 'ai-experiences', label: 'AI' },
    { id: 'certifications', label: 'Credentials' },
    { id: 'awards-languages', label: 'Languages' },
    { id: 'projects', label: 'Projects' },
    { id: 'contact', label: 'Contact' }
  ];

  const toggleMenu = (): void => {
    setIsMenuOpen(!isMenuOpen);
  };



  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="font-bold text-xl text-blue-600"></div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            {navItems.map((item: NavItem) => (
              <Link
                key={item.id}
                to={item.id}
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                activeClass="bg-white text-blue-600 border border-blue-600"
                className="px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer text-gray-700 hover:text-blue-600 hover:bg-white border hover:border-blue-600"
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-700 hover:text-blue-600 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="absolute left-0 right-0 top-16 border-t bg-white px-4 pb-4 shadow-md md:hidden">
            <div className="mx-auto flex max-w-4xl flex-col space-y-2 pt-2">
              {navItems.map((item: NavItem) => (
                <Link
                  key={item.id}
                  to={item.id}
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={500}
                  activeClass="bg-white text-blue-600 border border-blue-600"
                  onClick={() => setIsMenuOpen(false)}
                  className="px-3 py-2 rounded-md text-sm font-medium text-left transition-colors cursor-pointer text-gray-700 hover:text-blue-600 hover:bg-white border hover:border-blue-600"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navigation;
